import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Line } from 'react-chartjs-2';
import { useTheme } from '@material-ui/core';
import Chart from 'chart.js';

import { ApplicationState } from '../../../../../store';
import { MonthlyTracking } from '../../../../../store/modules/boxes/types';
import BaseBox from '../_Common/BaseBox';
import NoData from '../_Common/NoData';
import CustomCircularProgress from '../_Common/CustomCircularProgress';
import { Container } from './MonthlyTrackingStyles';
import { formatPrice } from '../../../../../utils/functions';

export default function BestAndWorseTrade() {
  const { loading, boxes } = useSelector(
    (state: ApplicationState) => state.boxes
  );
  const initialState: MonthlyTracking = {
    labels: [],
    values: [],
  };
  const [parsedData, setParsedData] = useState<MonthlyTracking>(initialState);
  const theme = useTheme();

  Chart.defaults.global.defaultFontColor = '#ffffffcc';
  Chart.defaults.global.defaultFontFamily = "'Roboto', sans-serif";

  const options = {
    tooltips: {
      backgroundColor: '#1e2141f0',
      titleFontSize: 13,
      bodyFontSize: 13,
      cornerRadius: 8,
      xPadding: 12,
      yPadding: 10,
      displayColors: false,
      callbacks: {
        label: function(tooltipItem: any) {
          return formatPrice(tooltipItem.yLabel);
        },
      },
    },
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            fontSize: 11,
            fontColor: '#ffffff88',
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: '#ffffff12',
            zeroLineColor: '#ffffff40',
            drawBorder: false,
          },
          ticks: {
            fontSize: 11,
            fontColor: '#ffffff88',
            callback: function(value: any) {
              if (value >= 1000 || value <= -1000) {
                return (value / 1000).toFixed(1) + 'k';
              }
              return value;
            },
          },
        },
      ],
    },
    maintainAspectRatio: false,
  };

  let data = {};

  if (boxes.MonthlyTracking) {
    const values = [...boxes.MonthlyTracking.values];
    const colors = values.map(function(v: number) {
      return v >= 0 ? '#4BDC4B' : '#FF6347';
    });

    data = {
      labels: [...boxes.MonthlyTracking.labels],
      datasets: [
        {
          label: 'Resultado',
          fill: true,
          backgroundColor: 'rgba(255, 238, 88, 0.08)',
          lineTension: 0.3,
          borderColor: theme.colors.primary,
          borderWidth: 2,
          pointBorderColor: colors,
          pointBackgroundColor: colors,
          pointBorderWidth: 2,
          pointHoverRadius: 6,
          pointHoverBackgroundColor: colors,
          pointHoverBorderColor: '#fff',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 12,
          data: values,
        },
      ],
    };
  }

  useEffect(() => {
    if (boxes.MonthlyTracking) {
      setParsedData(boxes.MonthlyTracking);
    }
  }, [boxes.MonthlyTracking]);

  return (
    <BaseBox title="Acompanhamento mensal" id="tour-box-monthly">
      {!(loading && parsedData.values.length === 0) && parsedData.values.length > 0 && (
        <Container>
          <Line options={options} data={data} />
        </Container>
      )}
      {loading && parsedData.values.length === 0 && <CustomCircularProgress />}
      {!loading && parsedData.values.length === 0 && <NoData />}
    </BaseBox>
  );
}
